'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { Span } from 'atoms/Typography';
import { Price } from 'molecules/Price';
import { useTranslations } from 'modules/i18n/useTranslations';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import styles from './styles.module.css';

interface IProps {
  price: IAdaptedProduct['price'];
  className?: string;
}

export const ProductReferencePrice: FC<IProps> = ({ price, className }) => {
  const t = useTranslations();
  const { reference } = price;

  return !reference ? null : (
    <span className={clsx(styles.productReferencePrice, className)}>
      <Price
        amount={reference.withTax}
        currencyCode={price.currencyCode}
        isCrossed={false}
        size="regular"
      />
      <Span>
        {t('product.pdp.header.per')} {reference?.size} {reference?.unit}
      </Span>
    </span>
  );
};
